/**
 * App config. All env-based values in one place.
 * For production: set REACT_APP_API_URL at build time (e.g. in CI or .env.production).
 */

/**
 * App version, stamped at build/start time from client/package.json by the
 * npm scripts (REACT_APP_VERSION=$npm_package_version). Empty when the bundle
 * was built some other way; the sidebar then shows nothing.
 */
export const APP_VERSION = process.env.REACT_APP_VERSION || '';

export const API_BASE_URL =
  process.env.REACT_APP_API_URL || 'http://localhost:4000';

/**
 * Resolve icon/image URL for display. Relative paths (e.g. /images/x.png) are resolved
 * against the current origin so they work when the app is deployed behind a proxy or subpath.
 */
export function getImageUrl(url) {
  if (!url || !String(url).trim()) return '';
  const u = String(url).trim();
  if (u.startsWith('http://') || u.startsWith('https://')) return u;
  if (u.startsWith('/') && typeof window !== 'undefined') return window.location.origin + u;
  return u;
}
